import { Routes } from "@angular/router";
import { provideEffects } from "@ngrx/effects";
import { provideState } from "@ngrx/store";
import { SsoLoginStore } from "./common/signal-stores/login/sso-login.store";
import { UpdateActiveStatusEffects } from "./common/stores/active-status/active-status.effect";
import { UserActiveStatusReducer } from "./common/stores/active-status/active-status.reducer";
import { selectActiveStatus } from "./common/stores/active-status/active-status.selectors";
import { ViewUpgardePlanInfoEffects } from "./common/stores/upgrade-plan/upgrade-plan.effect";
import { ViewUpgardePlanInfoReducer } from "./common/stores/upgrade-plan/upgrade-plan.reducer";
import { RoutesConstant } from "./constant/routes-constant";
import { authGuard } from "./guards/auth/auth.guard";

export const routes: Routes = [
  {
    path: "",
    pathMatch: "full",
    redirectTo: "login",
  },
  {
    path: "",
    loadComponent: () =>
      import("./common/auth-feature/auth-wrapper/auth-wrapper.component").then(
        (comp) => comp.AuthWrapperComponent
      ),
    loadChildren: () =>
      import("./common/auth-feature/auth.routes").then((m) => m.authRoutes),

    providers: [
      SsoLoginStore,
      provideState(selectActiveStatus, UserActiveStatusReducer),
      provideEffects(UpdateActiveStatusEffects),
    ],
  },

  // Platform Route Path
  {
    path: RoutesConstant.MainPath,
    canActivate: [authGuard],
    loadComponent: () =>
      import(
        "./common/main-content-wrapper/main-content-wrapper.component"
      ).then((comp) => comp.MainContentWrapperComponent),
    loadChildren: () =>
      import("./platform/platform.routes").then((m) => m.routes),
  },

  // Upgrade Route Path
  {
    path: RoutesConstant.UpgradePlan,
    loadComponent: () =>
      import(
        "./platform/settings/org-info/upgrade-plan/upgrade-plan.component"
      ).then((comp) => comp.UpgradePlanComponent),
    providers: [
      provideState("Upgardeplan", ViewUpgardePlanInfoReducer),
      provideEffects(ViewUpgardePlanInfoEffects),
    ],
  },
  {
    path: "**",
    loadComponent: () =>
      import("./common/page-not-found/page-not-found.component").then(
        (comp) => comp.PageNotFoundComponent
      ),
  },
];
